class Credit {
	constructor({
		consumed,
		quantity,
	} = {}) {
		this._consumed = consumed || 0;
		this._quantity = quantity || 0;
	}

	getKey = () => '';

	getQuantity = () => this._quantity;

	getConsumed = () => this._consumed;

	getRest= () => this._quantity - this._consumed;

}

export default Credit;
